import { render, staticRenderFns } from "./Parm.vue?vue&type=template&id=1773144a&scoped=true&"
import script from "./Parm.vue?vue&type=script&lang=js&"
export * from "./Parm.vue?vue&type=script&lang=js&"
import style0 from "./Parm.vue?vue&type=style&index=0&id=1773144a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1773144a",
  null
  
)

export default component.exports